var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconlanguage = function SvgIconlanguage(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 216,
    height: 190,
    viewBox: "0 0 216 190",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.241,
    y1: 0.075,
    x2: 0.71,
    y2: 0.944,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7fb1cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a74aa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.296,
    y1: 0.073,
    x2: 0.776,
    y2: 0.951,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9dcdbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b845c"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_6857",
    x: 111,
    y: 141,
    width: 67,
    height: 49,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_6858",
    x: 40,
    y: 134,
    width: 67,
    height: 49,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_6859",
    x: 0,
    y: 91,
    width: 67,
    height: 49,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_6860",
    x: 149,
    y: 32,
    width: 67,
    height: 49,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_6861",
    x: 135,
    y: 91,
    width: 67,
    height: 49,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_6862",
    x: 11,
    y: 41,
    width: 67,
    height: 50,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_6863",
    x: 78,
    y: 0,
    width: 67,
    height: 50,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon.language",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-globe",
    transform: "translate(43 28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4759",
    "data-name": "Path 4759",
    d: "M114,59A55,55,0,1,1,59,4,55,55,0,0,1,114,59Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4760",
    "data-name": "Path 4760",
    d: "M58.367,87.9a8.366,8.366,0,0,1-.63,5.651c-.619,1.881-1.249,4.392-2.511,5.64a13,13,0,0,1-3.759,2.522c-1.881,1.248-3.141,3.759-5.022,5.651,0,.619-2.511,3.812-3.14,3.812-.234.124-.457.236-.682.349a54.6,54.6,0,0,1-10.552-4.59c-.022-.066-.047-.129-.072-.2,0-.63-.619-4.4-.619-5.021-.63-1.889-1.262-4.4-1.889-6.281-1.248-3.14-3.759-6.281-3.759-10.04,0-3.143.619-6.27-1.262-8.792-2.511-3.141-7.532-3.141-10.043-5.021-3.773-2.511-7.532-6.27-9.413-10.043a11.78,11.78,0,0,1-1-2.112c0-.146-.017-.28-.017-.423A54.757,54.757,0,0,1,19.257,21.05c5.159-4.172,15.221-6.091,21.329-4.249,1.881.619,8.649,4.667,8.649,6.548,0,.63,0,.63-.63,1.262a2.286,2.286,0,0,1-1.881.63c-1.881,0-7.807-1.367-8.44-2-3.773-1.26-9.413,6.9-10.04,9.413-.63,1.889-.63,6.281,2.511,6.911,1.881,0,10.488-7.3,11.751-7.934,5.022-.619,8.9,3.685,10.164,8.088,1.881,5.021-8.731,9.875-12.5,11.137-1.249.63-1.878-.63-3.14,0-3.13,1.249-4.98,4.053-5.354,7.807-.316,3.176-.63,6.273-1.249,9.413-.63,0-1.919-.008-1.919-.638V66.191c0-1.895-.63-4.4-2.511-5.032-.63-.616-1.518.374-2.148.374-1.881,0-3.759-1.889-5.64-.63a7.706,7.706,0,0,0-2.511,5.021,2.309,2.309,0,0,0,.619,1.881c1.262.63,2.511-.619,3.773,0,1.249,0,1.249,1.262,1.249,1.889,1.262,1.881,2.511,4.392,4.4,5.021H38.284c1.881.63,5.022,1.248,6.281,2.511.616,1.249.616,2.511,1.249,3.759,3.141,3.14,6.9,3.14,10.67,4.4C57.738,86.016,58.37,86.635,58.367,87.9ZM93.441,16.155a7.118,7.118,0,0,0-.828.275c-1.881.63-6.79,9.694-8.046,11.572-.63.63-1.248,1.881-.63,2.511,0,.63.63.63,1.262.63,1.249.63,1.419.891,2.679,1.51.63,0,1.248.63.63,1.262a.617.617,0,0,1-.63.63c-3.141,3.14-6.281,5.651-9.413,8.781a4.385,4.385,0,0,0-1.053,2.514c0,.63.421.63.421,1.262s-.63.63-1.262,1.249a14.035,14.035,0,0,0-3.141,1.889c-.619,1.249,0,3.141-.619,4.392-.633,3.14-2.522,5.651-3.773,8.792-1.262,1.881-2.387,3.759-3.649,5.651,0,2.511-.63,4.392.63,6.27,3.14,4.4,9.427.19,13.819,2.068,1.248.63,2.324.745,3.14,1.881,1.559,2.164,1.749,6.724,2.382,8.616a34.522,34.522,0,0,0,2.511,7.532c.624,3.113,1.856,6.223,2.491,8.709a54.93,54.93,0,0,0,3.08-87.994ZM71.672,18.732a10.822,10.822,0,0,0,3.748-5.393c.613-1.2,2.494-3.6,1.87-5.393-.487-.935-2.467-1.5-3.913-1.983A54.993,54.993,0,0,0,59,4c-1.265,0-2.505.1-3.748.19a3.428,3.428,0,0,0-2.291,1.964c-.627,2.995,1.87,2.392,4.361,2.995,0,0,.627,4.791.627,5.393.627,2.995-1.251,4.791-1.251,7.777,0,1.8,0,4.8,1.251,6h.627c.627,0,1.24-.6,2.494-1.191,1.87-1.2,3.748-2.995,5.615-4.2A35.645,35.645,0,0,0,71.672,18.732Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_6857)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6857-2",
    "data-name": "Rectangle 6857",
    width: 49,
    height: 31,
    rx: 5,
    transform: "translate(120 147)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_6858)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6858-2",
    "data-name": "Rectangle 6858",
    width: 49,
    height: 31,
    rx: 5,
    transform: "translate(49 140)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_6859)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6859-2",
    "data-name": "Rectangle 6859",
    width: 49,
    height: 31,
    rx: 5,
    transform: "translate(9 97)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_6860)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6860-2",
    "data-name": "Rectangle 6860",
    width: 49,
    height: 31,
    rx: 5,
    transform: "translate(158 38)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_6861)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6861-2",
    "data-name": "Rectangle 6861",
    width: 49,
    height: 31,
    rx: 5,
    transform: "translate(144 97)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_6862)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6862-2",
    "data-name": "Rectangle 6862",
    width: 49,
    height: 32,
    rx: 5,
    transform: "translate(20 47)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_6863)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6863-2",
    "data-name": "Rectangle 6863",
    width: 49,
    height: 32,
    rx: 5,
    transform: "translate(87 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6870",
    "data-name": "Rectangle 6870",
    width: 22,
    height: 4,
    rx: 2,
    transform: "translate(153 38)",
    fill: "#e70d55"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6892",
    "data-name": "Rectangle 6892",
    width: 29,
    height: 4,
    rx: 2,
    transform: "translate(5 97)",
    fill: "#3b9c7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6896",
    "data-name": "Rectangle 6896",
    width: 15,
    height: 4,
    rx: 2,
    transform: "translate(116 147)",
    fill: "#3b9c7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6882",
    "data-name": "Rectangle 6882",
    width: 22,
    height: 4,
    rx: 2,
    transform: "translate(45 140)",
    fill: "#e70d55"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6871",
    "data-name": "Rectangle 6871",
    width: 32,
    height: 2,
    rx: 1,
    transform: "translate(153 46)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6891",
    "data-name": "Rectangle 6891",
    width: 39,
    height: 2,
    rx: 1,
    transform: "translate(5 105)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6895",
    "data-name": "Rectangle 6895",
    width: 39,
    height: 2,
    rx: 1,
    transform: "translate(116 155)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6885",
    "data-name": "Rectangle 6885",
    width: 38,
    height: 2,
    rx: 1,
    transform: "translate(45 148)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6872",
    "data-name": "Rectangle 6872",
    width: 7,
    height: 2,
    rx: 1,
    transform: "translate(153 56)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6889",
    "data-name": "Rectangle 6889",
    width: 23,
    height: 2,
    rx: 1,
    transform: "translate(5 115)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6893",
    "data-name": "Rectangle 6893",
    width: 8,
    height: 2,
    rx: 1,
    transform: "translate(116 165)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6883",
    "data-name": "Rectangle 6883",
    width: 37,
    height: 2,
    rx: 1,
    transform: "translate(45 158)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6873",
    "data-name": "Rectangle 6873",
    width: 40,
    height: 2,
    rx: 1,
    transform: "translate(153 51)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6890",
    "data-name": "Rectangle 6890",
    width: 39,
    height: 2,
    rx: 1,
    transform: "translate(5 110)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6894",
    "data-name": "Rectangle 6894",
    width: 22,
    height: 2,
    rx: 1,
    transform: "translate(116 160)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6884",
    "data-name": "Rectangle 6884",
    width: 30,
    height: 2,
    rx: 1,
    transform: "translate(45 153)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6874",
    "data-name": "Rectangle 6874",
    width: 19,
    height: 4,
    rx: 2,
    transform: "translate(82 7)",
    fill: "#1a74aa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6881",
    "data-name": "Rectangle 6881",
    width: 35,
    height: 4,
    rx: 2,
    transform: "translate(139 99)",
    fill: "#1a74aa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6888",
    "data-name": "Rectangle 6888",
    width: 35,
    height: 4,
    rx: 2,
    transform: "translate(15 50)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6875",
    "data-name": "Rectangle 6875",
    width: 41,
    height: 2,
    rx: 1,
    transform: "translate(82 15)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6880",
    "data-name": "Rectangle 6880",
    width: 41,
    height: 2,
    rx: 1,
    transform: "translate(139 107)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6887",
    "data-name": "Rectangle 6887",
    width: 41,
    height: 2,
    rx: 1,
    transform: "translate(15 58)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6876",
    "data-name": "Rectangle 6876",
    width: 7,
    height: 2,
    rx: 1,
    transform: "translate(82 25)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6877",
    "data-name": "Rectangle 6877",
    width: 41,
    height: 2,
    rx: 1,
    transform: "translate(82 20)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6879",
    "data-name": "Rectangle 6879",
    width: 19,
    height: 2,
    rx: 1,
    transform: "translate(139 112)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6886",
    "data-name": "Rectangle 6886",
    width: 19,
    height: 2,
    rx: 1,
    transform: "translate(15 63)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_302",
    "data-name": "Line 302",
    x2: 12,
    y2: 14,
    transform: "translate(121.5 81.5)",
    fill: "none",
    stroke: "#fac17c",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeDasharray: "0.1 8"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_303",
    "data-name": "Line 303",
    y1: 11,
    x2: 12,
    transform: "translate(135.5 63.5)",
    fill: "none",
    stroke: "#fac17c",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeDasharray: "0.1 8"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_304",
    "data-name": "Line 304",
    x2: 12,
    y2: 13,
    transform: "translate(62.5 68)",
    fill: "none",
    stroke: "#fac17c",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeDasharray: "0.1 8"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_305",
    "data-name": "Line 305",
    x2: 20,
    y2: 5.5,
    transform: "translate(52.5 109.5)",
    fill: "none",
    stroke: "#fac17c",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeDasharray: "0.1 8"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_306",
    "data-name": "Line 306",
    y1: 15,
    x2: 10,
    transform: "translate(86.5 117.5)",
    fill: "none",
    stroke: "#fac17c",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeDasharray: "0.1 8"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_307",
    "data-name": "Line 307",
    x1: 12,
    y1: 13,
    transform: "translate(135.5 125.5)",
    fill: "none",
    stroke: "#fac17c",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeDasharray: "0.1 8"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_308",
    "data-name": "Line 308",
    x1: 10,
    y2: 14.5,
    transform: "translate(74.5 34.5)",
    fill: "none",
    stroke: "#fac17c",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeDasharray: "0.1 8"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconlanguage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.language.4885a4d28752d4de12ebcc4242827a9e.svg";